export enum ValuationType {
  rental = 'RENTAL',
  sale = 'SALE',
}

export type ValueEstimateConfidence = {
  label?: string | null;
  type: 'HIGH' | 'LOW' | 'MEDIUM' | 'UNKNOWN';
};

export type Currency = {
  value: number;
  valueWithUnit: string;
};

export type ValueEstimateRange = {
  max: Currency;
  maxTitle: string;
  min: Currency;
  minTitle: string;
};
